import { PleaCards } from "../../../Components/Plea/PleaCard";
import CardHeader from "../../../antd/components/CardHeader";
import { useParams } from "react-router-dom";
import { useContext } from "react";
import './styles.css';


const TechnicalPlea = require("../../../Assets/icons/TechnicalPlea.png");
const TechnicalSchedule = require("../../../Assets/icons/TechnicalSchedule.png");
const Budget = require("../../../Assets/icons/Budget.png");
const SocioEnvironmental = require("../../../Assets/icons/SocioEnvironmental.png");

export default function CardsOptions() {
    const { id, pleaId } = useParams();

    return (
        <div className='card' style={{ margin: '10px' }}>
            <CardHeader
                pageName={"Cadastro"}
                hasPageBefore={false}
            />
            <div className="cards-container">
                <PleaCards
                    text="Pleito Técnico"
                    imageSrc={TechnicalPlea}
                    route={`/plea/technical/${pleaId}/${id}`}
                />
                <PleaCards
                    text="Cronograma Técnico do Agrupamento"
                    imageSrc={TechnicalSchedule}
                    route={`/plea/schedule/${id}/${pleaId}`}
                />
                <PleaCards
                    text="Orçamento"
                    imageSrc={Budget}
                    route={`/plea/budget/${id}/${pleaId}`}
                />
                <PleaCards
                    text="Socioambientais e Premissas"
                    imageSrc={SocioEnvironmental}
                    route={`/plea/biological/${pleaId}/${id}`}
                    pleaId={pleaId}
                />
            </div>
        </div>
    );
}